
import { defineComponent, ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/store';

import Navbar from '@/components/Navbar.vue';

export default defineComponent({
	components: {
		Navbar,
	},
	setup() {
		document.title = 'subreddits | (not) reddit';
		store.subreddits.actions.bindSubreddits();
		const router = useRouter();
		const createSubredditOn = ref(false);
		const currentInput = reactive({
			name: '',
			description: '',
			image: '',
		});

		async function createSubreddit() {
			if (!store.auth.state.isLoggedIn) return alert('Please make an account or sign in to make a subreddit.');
			if (/\s/g.test(currentInput.name)) return alert('Your title must not have any spaces.');
			if (!/^[0-9a-zA-Z]+$/.test(currentInput.name)) return alert('Your title must not contain special characters.');
			if (!currentInput.name.replace(/\s/g, '').length) return alert('Your title cannot be empty.');
			if (!currentInput.description.replace(/\s/g, '').length) return alert('Your description must not be empty.');
			if (currentInput.image.length && !currentInput.image.match(/^https:\/\//gi)) return alert(`Your image must be an https link.`);
			if (store.subreddits.state.subreddits.some((x) => x.name.toLowerCase() === currentInput.name.toLowerCase()))
				return alert('This subreddit already exists.');

			currentInput.description = currentInput.description.replace(/\r?\n|\r/g, ' ');

			const newSubreddit: { name: string; description: string; user_id: string; image?: string; id_token?: string } = {
				name: currentInput.name,
				description: currentInput.description,
				user_id: store.auth.state.user?.id || '',
			};

			if (currentInput.image.replace(/\s/g, '').length) newSubreddit.image = currentInput.image;
			await store.subreddits.actions.submitNewSubreddit(newSubreddit);
			currentInput.name = '';
			currentInput.description = '';
			currentInput.image = '';
			createSubredditOn.value = false;
		}

		return {
			store,
			router,
			createSubredditOn,
			currentInput,
			createSubreddit,
		};
	},
});
